import type {DateRange} from '../models/dateTime/dateRange';

/**
 * Returns an optional userId path suffix, that can be used for API endpoints
 * that may contain an userId as last route component
 */
export function userIdPath(userId?: string): string {
    return userId ? `/${userId}` : '';
}

/**
 * Maps the passed date ranges into an suitable format for the API.
 */
export function getDateRangesApiModel(dateRanges: readonly DateRange[]) {
    return {
        dateTimes: dateRanges.map(item => ({
            from: item.from.format('YYYY-MM-DDTHH:mm:ss'),
            until: item.to.format('YYYY-MM-DDTHH:mm:ss'),
        })),
    };
}
